import React from "react";
import { Modal } from "react-bootstrap";

interface IProps {
    show: boolean;
    onHideHandler?: () => void;
    closeOnOutClick?: boolean;
    className?: string;
    headerClassName?: string;
    bodyClassName?: string;
    footerClassName?: string;
    color?: "red";
    centered?: boolean;
    title?: JSX.Element;
    body: JSX.Element;
    footer?: JSX.Element;
    size?: "sm" | "lg" | "xl" | undefined;
}

class BaseModal extends React.Component<IProps> {
    private getColor = (): string => {
        switch (this.props.color) {
            case "red":
                return "modal-danger";
            default:
                return "";
        }
    };

    public render(): JSX.Element {
        const {
            show,
            onHideHandler,
            closeOnOutClick,
            centered,
            className,
            headerClassName,
            bodyClassName,
            footerClassName,
            title,
            body,
            footer,
            size,
        } = this.props;

        return (
            <Modal
                show={show}
                onHide={onHideHandler}
                size={size}
                centered={centered}
                backdrop={closeOnOutClick === false ? "static" : true}
                dialogClassName={[className, this.getColor()].join(" ")}
            >
                {title ? (
                    <Modal.Header closeButton className={headerClassName}>
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                ) : null}
                <Modal.Body className={bodyClassName}>{body}</Modal.Body>
                {footer ? <Modal.Footer className={footerClassName}>{footer}</Modal.Footer> : null}
            </Modal>
        );
    }
}

export { BaseModal as Unconnected };
export default BaseModal;
